import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import January from "../views/January.vue";
import February from "../views/February.vue";
import March from "../views/March.vue";
import April from "../views/April.vue";
import May from "../views/May.vue";
import June from "../views/June.vue";
import July from "../views/July.vue";
import August from "../views/August.vue";
import September from "../views/September.vue";
import October from "../views/October.vue";
import November from "../views/November.vue";
import December from "../views/December.vue";
import Alif from "../views/Alif.vue";
import Alif2 from "../views/Alif2.vue";
import AlifKasra from "../views/AlifKasra.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/january",
    name: "January",
    component: January,
  },
  {
    path: "/february",
    name: "February",
    component: February,
  },
  {
    path: "/march",
    name: "March",
    component: March,
  },
  {
    path: "/april",
    name: "April",
    component: April,
  },
  {
    path: "/may",
    name: "May",
    component: May,
  },
  {
    path: "/june",
    name: "June",
    component: June,
  },
  {
    path: "/july",
    name: "July",
    component: July,
  },
  {
    path: "/august",
    name: "August",
    component: August,
  },
  {
    path: "/september",
    name: "September",
    component: September,
  },
  {
    path: "/october",
    name: "October",
    component: October,
  },
  {
    path: "/november",
    name: "November",
    component: November,
  },
  {
    path: "/december",
    name: "December",
    component: December,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/alif",
    name: "Alif",
    component: Alif,
  },
  {
    path: "/alif2",
    name: "Alif2",
    component: Alif2,
  },
  {
    path: "/alif-kasra",
    name: "AlifKasra",
    component: AlifKasra,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
